import { render, staticRenderFns } from "./NumberFilter.vue?vue&type=template&id=d24d4bca&scoped=true"
import script from "./NumberFilter.vue?vue&type=script&lang=ts"
export * from "./NumberFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d4bca",
  null
  
)

export default component.exports